//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { localeStore } from '@/store/locale';import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BffClientBase {
  constructor() {
  }

  protected transformOptions(options: AxiosRequestConfig) {
    options.headers['Accept-Language'] = localeStore().locale
    return Promise.resolve(options)
  }

  protected transformResult(url: string, response: AxiosResponse<any>, processor: (response: AxiosResponse<any>) => any) {
    const contentType = response.headers['content-type'] as string
    if (contentType && contentType.indexOf('text/html') >= 0) {
      const loc = `${location.protocol}//${location.hostname}:${location.port}`
      if (response.request.responseURL.indexOf(loc) < 0) {
        const unauthorizedError = {
          status: 401,
          statusText: response.request.responseURL,
        }
        throw unauthorizedError
      }
    }
    return processor(response)
  }
}

export interface IWerkClient {
    /**
     * @return OK
     */
    werk_GetKlant(insz: string): Promise<GetKlantVolgSysteemResponse>;
}

export class WerkClient extends BffClientBase implements IWerkClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:48887";

    }

    /**
     * @return OK
     */
    werk_GetKlant(insz: string, cancelToken?: CancelToken | undefined): Promise<GetKlantVolgSysteemResponse> {
        let url_ = this.baseUrl + "/api/v1/werk/{insz}";
        if (insz === undefined || insz === null)
            throw new Error("The parameter 'insz' must be defined.");
        url_ = url_.replace("{insz}", encodeURIComponent("" + insz));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWerk_GetKlant(_response));
        });
    }

    protected processWerk_GetKlant(response: AxiosResponse): Promise<GetKlantVolgSysteemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GetKlantVolgSysteemResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKlantVolgSysteemResponse>(null as any);
    }
}

export interface GetKlantVolgSysteemResponse {
    dienstverleningen?: PubliekeDienstverlening[];
}

export interface PubliekeDienstverlening {
    naam?: string;
    type?: LabelOmschrijving | undefined;
    finaliteit?: LabelOmschrijving | undefined;
    verantwoordelijke?: Participant;
    werkvoorkeuren?: Werkvoorkeur[];
    participanten?: Participant[];
    trajecten?: Traject[];
    contactInfo?: ContactInfo;
}

export interface LabelOmschrijving {
    label?: string;
    omschrijving?: string;
}

export interface Participant {
    voornaam?: string;
    achternaam?: string;
    voorkeursnaam?: string;
    rol?: LabelOmschrijving;
    identificator?: Identificator;
    contactInfo?: ContactInfo;
}

export interface Identificator {
    value?: string;
    uitgereiktDoor?: string;
}

export interface ContactInfo {
    email?: string[];
    telefoon?: string[];
    adres?: Adres[];
}

export interface Adres {
    straatnaam?: string;
    huisnummer?: string;
    bus?: string;
    postcode?: string;
    gemeente?: string;
    land?: string;
}

export interface Werkvoorkeur {
    naam?: string;
    voorkeur?: LabelOmschrijving;
}

export interface Traject {
    naam?: string;
    startDatum?: Date | undefined;
    eindDatum?: Date | undefined;
    type?: LabelOmschrijving;
    status?: LabelOmschrijving;
    participanten?: Participant[];
    deelTrajecten?: Traject[];
}

export interface ErrorMessage {
    type?: string | undefined;
    title: string;
    status?: number;
    detail: string;
    instance?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}